export default __webpack_public_path__ + "static/media/about-content.bd004a20.png";